export const API_URL = process.env.VUE_APP_API_URL || 'localhost'
export const GET_ENDPOINT_URL = process.env.VUE_APP_GET_ENDPOINT_URL || 'localhost'
export const GET_SYSTEM_CONFIG_URL = process.env.VUE_APP_GET_SYSTEM_CONFIG_URL || 'localhost'
export const GET_SYSTEM_CONFIG_CCRP = process.env.VUE_APP_GET_CCRP_CONFIG || 'localhost'
export const DOMAIN_TITLE = process.env.VUE_APP_DOMAIN_TITLE || 'Nextpay CRM'
export const TOKEN_INSIDE = process.env.VUE_APP_INSIDE_TOKEN || 'TOKEN_INSIDE'
